import { ReferenceListing } from '@/types-reference-listing';
import { createRequest } from './fetch';

function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : 'Unknown error';
}

function getReferenceListingsEndpointUrl(customerId: string): string {
  return `${import.meta.env.VUE_APP_REFERENCE_LISTINGS_BASE_URL}/customers/${customerId}/reference-listings`;
}

function getReferenceListingByIdEndpointUrl(referenceListingId: string): string {
  return `${import.meta.env.VUE_APP_REFERENCE_LISTINGS_BASE_URL}/reference-listings/${encodeURIComponent(referenceListingId)}`;
}

function putReferenceListingsEndpointUrl(): string {
  return `${import.meta.env.VUE_APP_REFERENCE_LISTINGS_BASE_URL}/reference-listings`;
}
export async function getReferenceListings(customerId: string): Promise<any[]> {
  try {
    if (!customerId) {
      throw new Error('Customer ID is required');
    }

    const response = await createRequest({ method: 'GET', credentials: 'omit' })(
      getReferenceListingsEndpointUrl(customerId),
    );

    const data = await response.json();

    if (!Array.isArray(data)) {
      throw new Error('Invalid response format: expected an array');
    }

    return data;
  } catch (error) {
    throw new Error(`Failed to fetch reference listings: ${getErrorMessage(error)}`);
  }
}

export async function deleteReferenceListingById(referenceListingId: string): Promise<void> {
  try {
    const { ok, status } = await createRequest({ method: 'DELETE', credentials: 'same-origin' })(
      getReferenceListingByIdEndpointUrl(referenceListingId),
    );
    if (!ok) {
      throw new Error(
        `Failed to delete reference listing ${referenceListingId} with response code: ${status}`,
      );
    }
  } catch (error) {
    throw new Error(
      `Failed to delete Reference Listing ${referenceListingId}: ${getErrorMessage(error)}`,
    );
  }
}

export const putReferenceListing = async (payload: ReferenceListing): Promise<void> => {
  try {
    await createRequest({
      method: 'PUT',
      credentials: 'omit',
    })(putReferenceListingsEndpointUrl(), JSON.stringify(payload));
  } catch (error) {
    throw new Error(`Failed to save reference listing: ${getErrorMessage(error)}`);
  }
};
